import React from "react";
import { BookOpenCheck, ClipboardCheck, Sparkles } from "lucide-react";

const blogHighlights = [
  {
    label: "Strategy Guides",
    helper: "Practical PTE preparation workflows",
    icon: BookOpenCheck,
  },
  {
    label: "Exam Tips",
    helper: "Focused advice for every section",
    icon: ClipboardCheck,
  },
  {
    label: "AI Insights",
    helper: "Smarter ways to use PrepNexis",
    icon: Sparkles,
  },
];

const Jumbotron = () => {
  return (
    <div className="jumbotron homepage relative min-h-[300px] border-b border-slate-200 bg-slate-50 py-8 md:py-12">
      <div className="container relative mx-auto px-4">
        {/* Breadcrumbs */}
        <div className="breadcrumbs mb-5 flex items-center space-x-1 text-sm text-gray-500">
          <span>
            <a
              href="/"
              className="home"
              title="PrepNexa"
              aria-label="Home"
              data-wpel-link="internal"
            >
              <span className="sr-only">Home</span>
              <span className="hover:underline text-base font-medium hover:text-[rgb(126,34,206)]">
                Home
              </span>
            </a>
          </span>
          <span>/</span>
          <span>
            <span
              className="breadcrumb_last text-base font-semibold text-[rgb(126,34,206)]"
              aria-current="page"
            >
              Blog
            </span>
          </span>
        </div>

        {/* Jumbo Row */}
        <div className="jumbo-row relative grid gap-8 rounded-md border border-slate-200 bg-white p-5 shadow-sm md:p-8 lg:grid-cols-[1fr_360px] lg:items-stretch">
          {/* Left Section */}
          <div className="jumbotron-left flex flex-col justify-center">
            <span className="inline-flex w-fit rounded-sm bg-[rgba(126,34,206,0.08)] px-3 py-1 text-xs font-semibold uppercase text-[rgb(126,34,206)] ring-1 ring-[rgba(126,34,206,0.16)]">
              PTE preparation
            </span>
            <h1 className="mt-4 text-[38px] font-extrabold leading-tight text-gray-900 md:text-[52px]">
              PrepNexis blog
            </h1>
            <p className="mt-4 max-w-3xl text-[17px] leading-8 text-gray-600 md:text-[18px]">
              PrepNexis is committed to your PTE success and excellence. Stay
              tuned for updates, expert advice, and the latest resources to
              elevate your PTE preparation journey.
            </p>

            <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:flex-wrap">
              <a
                href="/blog/latest/"
                className="inline-flex items-center justify-center rounded-sm bg-[rgba(126,34,206,0.08)] px-5 py-3 text-sm font-semibold text-[rgb(126,34,206)] ring-1 ring-[rgba(126,34,206,0.16)] transition hover:bg-[rgba(126,34,206,0.12)]"
              >
                Explore latest posts
              </a>
              <a
                href="/signup"
                className="inline-flex items-center justify-center rounded-sm border border-slate-200 bg-white px-5 py-3 text-sm font-semibold text-gray-800 shadow-sm transition hover:border-[rgba(126,34,206,0.28)] hover:text-[rgb(126,34,206)]"
              >
                Start practicing
              </a>
            </div>
          </div>

          <div className="jumbotron-right">
            <div className="h-full rounded-md border border-slate-200 bg-slate-50 p-4 shadow-sm">
              <p className="text-sm font-semibold uppercase text-[rgb(126,34,206)]">
                Inside the blog
              </p>
              <div className="mt-4 space-y-3">
                {blogHighlights.map(({ label, helper, icon: Icon }) => (
                  <a
                    key={label}
                    href="/blog/latest/"
                    className="group flex gap-3 rounded-md bg-white p-3 shadow-sm transition hover:ring-1 hover:ring-[rgba(126,34,206,0.16)]"
                  >
                    <span className="grid h-10 w-10 shrink-0 place-items-center rounded-sm bg-[rgba(126,34,206,0.08)] text-[rgb(126,34,206)] transition group-hover:bg-[rgba(126,34,206,0.12)]">
                      <Icon className="h-5 w-5" aria-hidden="true" />
                    </span>
                    <span>
                      <span className="block font-bold text-gray-900">
                        {label}
                      </span>
                      <span className="mt-1 block text-sm text-gray-500">
                        {helper}
                      </span>
                    </span>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Jumbotron;
